import React, { useState } from 'react'
import Header from '../Core/Header'
import { diagonistics } from '../../Assets/dummyDiagons'

const ViewHospitals = () => {
    const[list,setList]=useState(diagonistics)
  return (
    <div style={{height:"100vh",width:"100%"}}>
        <Header/>
        <section style={{marginTop:"80px",height:"calc(100vh - 80px)",background: "linear-gradient(180deg, #555454ff, #ffffffff, #5f5f5fff)",padding:"20px"}}>
        <div style={{fontSize:"24px",fontWeight:"700",textAlign:"center",display:"flex",justifyContent:"space-around",padding:"6px"}}>
            <p style={{color:"white"}}>All Hospitals connected with us</p>
            <input placeholder='Search Hospital by name'
            style={{border:"0.5px solid white",
                borderRadius:"8px",
                fontSize:"16px",padding:"5px",
                backgroundColor:"white"
            }}/>
            </div>
        <div style={{height:"calc(100vh - 100px)",display:"flex",flexWrap:"wrap",width:"100%",overflowY:"auto",overflowX:"hidden"}}>
            {
            list.map((item)=>(
                <div style={{width:"22vw",minHeight:"40vh",maxHeight:"fit-content",borderRadius:"10px",padding:"10px",backgroundColor:"#c5c4c4ff",
                    display:"flex",flexDirection:"column",alignItems:"center",margin:"10px"
                }}>
                    <img src='/Assets/diagonasitic.jpg' style={{height:"70%",width:"85%",borderRadius:"10px"}}/>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"start",width:"90%"}}>
                        <p style={{fontSize:"20px",textAlign:"left",fontWeight:"500"}}>{item.name}</p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#d65d3eff"}}>Patients:{item.Patients}+</span>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#6fa0d8ff"}}>reg:{item.Registered}</span></p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'16px',fontWeight:"700",color:"#a3343aff"}}>{item.Address}</span></p>
                           
                        <p style={{fontSize:"14px",fontWeight:"800"}}>Medical Test provided</p>
                        <div style={{width:"100%",display:"flex",alignItems:"center",gap:"10px",flexWrap:"wrap"}}>
                            
                            {
                            item.TestProvided.map(i=>
                            <p style={{fontSize:"14px",padding:"3px",borderRadius:"8px",backgroundColor:"#041c3bff",color:"white"}}>{i}</p>)
                        }</div>
                            <p style={{fontSize:"14px",fontWeight:"800"}}>Assigned Doctors</p><br/>
                         <div style={{width:"100%",display:"flex",alignItems:"center",gap:"10px",flexWrap:"wrap"}}>
                            
                            {
                            item.Doctors.map(i=>
                            <p style={{fontSize:"14px",padding:"3px",borderRadius:"8px",backgroundColor:"#053d2cff",color:"#fcfcfcff"}}>{i}</p>)
                        }</div>
                     </div>

                    </div>
            ))
            }

        </div>

      </section>
     
    </div>
  )
}

export default ViewHospitals
